import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import BodyLogo from '../../components/BodyLogos/BodyLogo'
import LoginForm from '../../components/LoginForm/LoginForm'
export default function LoginPage() {
  return (
  <div className="auth-page">
  <Header />
  <LoginForm/>
  <BodyLogo/>
  <Footer/>
  </div>
  )
}
